"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaPassengerRoomSelection = require("./AaPassengerRoomSelection.model");

var _AaPassengerRoomSelectionStepper = _interopRequireDefault(require("./AaPassengerRoomSelection-Stepper.component"));

var _AaPassengerRoomSelection2 = _interopRequireDefault(require("./AaPassengerRoomSelection.styles"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var RoomSelection = function RoomSelection(props) {
  var roomCount = props.roomCount,
      roomNumber = props.roomNumber,
      stepperClicked = props.stepperClicked,
      translation = props.translation,
      selectionStepperConfig = props.selectionStepperConfig,
      min = props.min,
      max = props.max,
      showRemove = props.showRemove,
      removeRoom = props.removeRoom,
      ageList = props.ageList;
  var roomLabel = translation.roomLabel.replace('{0}', roomNumber);
  var childAgeLabel = translation && translation.childAgeDropdownLabel ? translation.childAgeDropdownLabel : 'Child {0} age';

  var stepperCommonControls = _objectSpread(_objectSpread({}, selectionStepperConfig.controls), {}, {
    accessibilityProps: {
      addButtonProps: {
        accessibilityLabel: translation.accessibility && translation.accessibility.paxAdultAdd
      },
      removeButtonProps: {
        accessibilityLabel: translation.accessibility && translation.accessibility.paxAdultRemove
      }
    },
    stepperClicked: stepperClicked
  });

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _AaPassengerRoomSelection2["default"].roomHeader
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: _AaPassengerRoomSelection2["default"].roomLabel
  }, roomLabel), showRemove && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    accessibilityRole: "button",
    onPress: removeRoom
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: _AaPassengerRoomSelection2["default"].link
  }, translation.removeRoom))), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _AaPassengerRoomSelection2["default"].line
  }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
    controls: _objectSpread({
      type: _AaPassengerRoomSelection.PASSENGER_TYPE.ADULT,
      min: min.adult,
      max: max.adult
    }, stepperCommonControls),
    data: roomCount.adult
  }), /*#__PURE__*/_react["default"].createElement(_AaPassengerRoomSelectionStepper["default"], {
    controls: _objectSpread({
      type: _AaPassengerRoomSelection.PASSENGER_TYPE.CHILD,
      min: min.child,
      max: max.child
    }, stepperCommonControls),
    ageList: ageList,
    childAgeData: roomCount.childAges,
    data: roomCount.child,
    childAgeLabel: childAgeLabel
  }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _AaPassengerRoomSelection2["default"].line
  }));
};

var _default = RoomSelection;
exports["default"] = _default;